import { FormControl, Input as MuiInput, Typography } from '@mui/material';

import React, { memo } from 'react';

function ControlledInput({
  error,
  fullWidth = true,
  label,
  sx,
  labelSize,
  ...rest
}: any) {
  return (
    <FormControl fullWidth={fullWidth}>
      {label && (
        <Typography
          fontSize={labelSize ? labelSize : '14px'}
          fontWeight={500}
          mb={1}
          variant="body1"
        >
          {label}
        </Typography>
      )}
      <MuiInput
        disableUnderline
        sx={{
          background: (theme) => theme.palette.background.paper,
          borderRadius: '2rem',
          fontSize: 'small',
          padding: (theme) => theme.spacing(1, 2),
          border: () => (error ? '1px solid #E84933' : '1px solid #c6c6c6'),
          ...sx, // Merge the sx prop here
        }}
        variant="outlined"
        {...rest}
      />
      {error && (
        <Typography sx={{ color: '#E84933' }} variant="caption">
          {error}
        </Typography>
      )}
    </FormControl>
  );
}

export default memo(ControlledInput);
